module.exports = {
  eventCategory: 'Editor UI | Tool Menu | images',

  show: { eventAction: 'show' },
  openSearchTabEvent: { eventAction: 'open_search_tab' },

  listContentToggleEvent: function (event) {
    var $button = $(event.currentTarget);
    var $container = $button.closest('dt');

    $container.hasClass('active') || this.trackEvent({
      eventAction: 'content_toggle',
      eventLabel: $button.data('key')
    });
  }
};
